// export const IMG_URL = "http://127.0.0.1:4325";
// export const IMG_URL = "http://192.168.16.38:4325";
// export const IMG_URL = "https://driwenode.profcyma.org:4325";
export const IMG_URL = "https://driwenode.driwe.in:4321";


export const Per_Page_Dropdown = async (data) => {
  const a = [];
  for (let i = 5; i <= data; i *= 2) {
    a.push(i);
  }
  a.push(data);

  return a;
};

export const RequiredIs = {
  roles: [1, 2, 3, 4, 5, 6, 7],
};

export const Select2Data = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }

  return result;
};

export const getDimension = async (file) => {
  let reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    reader.onload = () => {
      var image = new Image();
      image.src = reader.result;
      image.onload = function () {
        resolve({ width: this.width, height: this.height });
      };
    };
    reader.readAsDataURL(file);
  });
};

export const RegxExpression = {
  name: /[A-Z-a-z ]/,
  email: /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z0-9_\-\.]+)\.\2)([A-Za-z0-9_\-\.]+\.)+([A-Za-z]{2,4})$/,
  phone: /[0-9]/,

  ifsc: "^[A-Z]{4}[0][dA-Z]{6}$",
  ifsc_code: /^[A-Z0-9]$/,
  micr: /^[0-9]{9}$/,
  bank_number: /^\d{0,14}$/,
  gst: /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[1-9A-Z]{1}$/,
};

export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
}


export const getLocationDetails = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported by your browser"));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        try {
          const res = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.REACT_APP_GOOGLE_MAP_API}`
          );
          const data = await res.json();

          if (data.status !== "OK") {
            resolve({ latitude, longitude, formatted_address: `${latitude}, ${longitude}` });
            return;
          }

          const components = data.results[0]?.address_components || [];

          const get = (type) =>
            components.find((c) => c.types.includes(type))?.long_name || "";

          resolve({
            latitude,
            longitude,
            formatted_address: data.results[0]?.formatted_address || "",
            street: get("route"),
            area: get("sublocality") || get("sublocality_level_1"),
            city: get("locality"),
            state: get("administrative_area_level_1"),
            country: get("country"),
            pincode: get("postal_code"),
          });

        } catch (error) {
          // Geocode failed — still return coords
          resolve({ latitude, longitude, formatted_address: `${latitude}, ${longitude}` });
        }
      },
      (error) => {
        const messages = {
          [error.PERMISSION_DENIED]: "Location permission denied.",
          [error.POSITION_UNAVAILABLE]: "Location information is unavailable.",
          [error.TIMEOUT]: "Location request timed out.",
        };
        reject(new Error(messages[error.code] || "Unable to retrieve location."));
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  });
};

